module.exports = __webpack_public_path__ + "assets/img/bw.cb17727.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/bw.png
// module id = 905
// module chunks = 39